import { AppProvider }  from './providers/appProvider';
import { BaseProvider } from './providers/baseProvider';
import { AppRouter }    from './routes/router';

const App = () => {
  return (
    <AppProvider>
      <BaseProvider>
        <AppRouter />
      </BaseProvider>
    </AppProvider>
  )
}

export default App;